<template>
  <div class="create-project">
    <v-container>
      <project-form
        :project="localProject"
        :patient="patient"
        @on-cancel="dialog = true"
        @on-submit="createProject"
        @on-product-click="goToProductPage(localProject)"
        :disable-product-btn="!projectUuid"
      ></project-form>

      <v-snackbar color="success" v-model="showSnackbar" :timeout="2000" top>
        {{ textSnackbar }}
        <v-btn text @click="showSnackbar = false">Fermer</v-btn>
      </v-snackbar>
    </v-container>

    <!-- Confirmation dialog -->
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Annulation</v-card-title>
        <v-card-text>Toutes modifications seront perdues !</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="red" :to="{name: 'LocalPatientList'}" dark text>Oui</v-btn>
          <v-btn @click="dialog = false" text color="black">Non</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
const uuidv4 = require("uuid/v4");

import { products } from "@/mixins/products";
import ProjectForm from "./components/ProjectForm";

export default {
  name: "CreateProject",
  mixins: [products],
  components: {
    ProjectForm
  },
  data() {
    return {
      // Patient
      patient: {},

      // Project
      localProject: {},

      // Flag to disable "Ouvrir diche applicateur" button
      projectUuid: null,

      showSnackbar: false,
      textSnackbar: "",
      dialog: false
    };
  },
  computed: {
    ...mapState({
      project: state => state.projects.project
    })
  },
  methods: {
    ...mapMutations({
      cleanProject: "projects/cleanProject"
    }),

    ...mapActions({
      cleanProject: "projects/cleanProject",
      createLocalPatient: "patients/createLocalPatient",
      createLocalProject: "projects/createLocalProject"
    }),

    // Load initial state
    async loadInitialState() {
      await this.cleanProject();
      this.localProject = JSON.parse(JSON.stringify(this.project));
    },

    // Create a patient
    async createPatient() {
      try {
        // Generate an uuid
        this.patient.uuid = uuidv4();

        // Set sync status -- not synced by default
        this.patient.sync = 0;

        return await this.createLocalPatient(this.patient);
      } catch (error) {
        alert(error);
      }
    },

    // Create a project
    async createProject() {
      try {
        // Creates a patient
        const patient = await this.createPatient();

        // Generates an uuid
        this.localProject.uuid = uuidv4();
        this.localProject.patient_uuid = patient;

        // Set sync status
        this.localProject.sync = 0;

        // Creates a local project
        await this.createLocalProject(this.localProject);
        const project = await this.$db.projects.get(this.localProject.uuid);

        // Creates a product linked with localProject
        await this.createProduct(project);

        this.localProject = await this.$db.projects.get(project);

        this.textSnackbar = "Projet créé";
        this.showSnackbar = true;

        this.projectUuid = true;

        return project;
      } catch (error) {
        console.log(error);
      }
    }
  },
  async created() {
    await this.loadInitialState();
  },
  beforeDestroy() {
    this.cleanProject();
  }
};
</script>

<style>
</style>